import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Page, Spinner, Text } from '@shopify/polaris';
import { useTranslation } from 'react-i18next';
import { isLocalDevelopment, isEmbeddedInShopify } from '../utils/env';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const { t } = useTranslation();

  const isLocal = isLocalDevelopment();
  const isEmbedded = isEmbeddedInShopify();

  if (loading) {
    return (
      <Page>
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          minHeight: '60vh',
          flexDirection: 'column',
          gap: '1rem'
        }}>
          <Spinner size="large" />
          <Text as="p" tone="subdued">
            {t('common.loading', { defaultValue: 'Carregando...' })}
          </Text>
        </div>
      </Page>
    );
  }

  // Se está em desenvolvimento local, permitir acesso sem autenticação
  if (isLocal) {
    return <>{children}</>;
  }

  // Se está embedado no Shopify, precisa de autenticação
  if (isEmbedded && !isAuthenticated) {
    return (
      <Page>
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          minHeight: '60vh',
          flexDirection: 'column',
          gap: '1rem'
        }}>
          <Spinner size="large" />
          <Text as="p" tone="subdued">
            {t('auth.authenticating', { defaultValue: 'Autenticando...' })}
          </Text>
        </div>
      </Page>
    );
  }

  // Se não está autenticado e não é local, redirecionar para login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};
